<template>
  <ion-page :key="reloadHomePage">
    <ion-header>
      <toolbar
        :selectedCompany="selectedCompany"
        :isLoadAllProduct="isLoadAllProducts"
        :isResetSearch="isResetSearch"
        :selectedTab="changeCategory"
        :isExploreProduct="isExploreProduct"
        :currentFilter="currentFilter"
        :isOnScrollTop="isOnScrollTop"
        @resetLoadAllProduct="setLoadAllProducts(false)"
        @resetSearch="resetSearch"
        @resetRef="resetRef"
        @clearPrevFilter="clearPrevFilter"
        @setIsHomePageValue="setIsHomePageValue"
        @reRenderToolbar="reFetchSelectedCompany"
      />
      <slides-cate @reset-search="resetSearch" @setExploreProduct="setExploreProduct" />
    </ion-header>
    <div class="wrapper" v-if="isComming">
      <div class="title">
        Maintenance on
        {{
          localtime.slice(0, 3) +
          ',' +
          localtime.slice(8, 10) +
          ' ' +
          localtime.slice(4, 7) +
          ',' +
          localtime.slice(16, 21) +
          ' ' +
          `(${localtime.slice(25, 31)})`
        }}
      </div>
      <div class="time">{{ `${hours}:${minutes}:${seconds}s` }}</div>
    </div>
    <invoice :key="new Date()" v-if="selectedCompany" />

    <ion-content
      ref="contentRef"
      :scroll-events="true"
      @ionScroll="handleScroll($event)"
      class="default-background"
    >
      <product-list
        @fetchAllProduct="setLoadAllProducts(true)"
        :changeCategory="changeCategory"
        :selectedNewCustomer="selectedCustomer"
        @load-data="loadData"
        @reloadHomePage="reloadHomePage++"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import { getItemByKey, useUpdateFilter } from '@/components/sort/composable';
import { apolloClient } from '@/main';
import { TYPE_SEARCH, defaultSize } from '@/modules/b2b/constants';
import { checkConnectPerson } from '@/modules/b2b/services/graphql';
import { ACTIONS as ACTIONS_CART } from '@/modules/b2b/store/cart/actions';
import { ACTIONS } from '@/modules/b2b/store/product/actions';
import { MUTATIONS } from '@/modules/b2b/store/product/mutations';
import {
  GETTER,
  MODULES_FILTER,
  SORTBY_FILTER_NAME,
  TAB_CATEGORY,
  USER_TYPE
} from '@/modules/shared/constants';
import { alertController } from '@ionic/vue';
import debounce from 'lodash.debounce';
import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: mapGettersVersion } = createNamespacedHelpers('b2b/version');
const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers('b2b/product');
const { mapGetters: mapGettersCustomer } = createNamespacedHelpers('b2b/customer');
const { mapGetters: mapGettersCart, mapActions: mapActionsCart } = createNamespacedHelpers('b2b/cart');
const { mapGetters: mapGettersExploreTabCategory } = createNamespacedHelpers('b2b/category');

export default defineComponent({
  name: 'HomeB2b',
  components: {
    Invoice: defineAsyncComponent(() => import('./components/OverdueNotif.vue')),
    Toolbar: defineAsyncComponent(() => import('./components/Toolbar.vue')),
    SlidesCate: defineAsyncComponent(() => import('./components/SlidesCate.vue')),
    ProductList: defineAsyncComponent(() => import('./components/ProductList.vue'))
  },
  inject: ['$storage'],
  setup() {
    const noProductIsLoaded = ref(false);
    const { onSetDefaultSort } = useUpdateFilter();
    const prevHistoryPath = ref('');
    const selectedCompany = ref(null);
    const user = ref(null);
    const isOnScrollTop = ref(false);
    const isLoadAllProducts = ref(false);
    const reloadHomePage = ref(1);
    const setLoadAllProducts = (state) => (isLoadAllProducts.value = state);
    return {
      noProductIsLoaded,
      onSetDefaultSort,
      prevHistoryPath,
      selectedCompany,
      user,
      isOnScrollTop,
      setLoadAllProducts,
      isLoadAllProducts,
      reloadHomePage,
      handleScroll: debounce((e) => {
        const onScrollHeightValue = e.detail.scrollTop;
        if (onScrollHeightValue > 10) isOnScrollTop.value = true;
        if (onScrollHeightValue === 0) isOnScrollTop.value = false;
      }, 200)
    };
  },
  data() {
    return {
      isResetSearch: null,
      hours: '',
      minutes: '',
      seconds: '',
      isComming: false,
      localtime: '',
      selectedTab: '',
      prevCate: '',
      currentPath: '',
      prevPath: '',
      changeCategory: TAB_CATEGORY.HISTORY,
      render: 1,
      isExploreProduct: false,
      isPageRefreshed: true,
      currentFilter: '',
      isHomePage: false
    };
  },
  async mounted() {
    this.user = await this.$storage.getUser();
  },
  async ionViewWillEnter() {
    const historyState = window.history.state;
    this.prevHistoryPath = historyState?.back;
    if (this.prevHistoryPath === '/b2b/search-products' || this.prevHistoryPath === '/b2b/cart') {
      await this[MUTATIONS.RESET_CATEGORY]();
      this.selectedTab = TAB_CATEGORY.HISTORY;
      this.search.mainCategoryId = this.selectedTab;
      this.changeCategory = this.selectedTab;
      await this[ACTIONS.UPDATE_SEARCH]({
        search: {
          ...this.search,
          searchQueries: '',
          mainCategoryId: TAB_CATEGORY.HISTORY,
          sortBy: SORTBY_FILTER_NAME.PURCHASED,
          sortType: 'desc',
          categories: [],
          offset: 0
        },
        type: TYPE_SEARCH.CATEGORY
      });
    }
  },

  async ionViewDidEnter() {
    const historyState = window.history.state;
    this.isHomePage = true;
    this.isOnScrollTop = false;

    this.user = await this.$storage.getUser();
    this.selectedCompany = await this.$storage.getSelectedCompany();

    if (this.finishOrder) {
      this.setLoadAllProducts(true);
      await this[ACTIONS_CART.FINISH_ORDER](false);
    }
    if (this.maintenance) {
      var date = new Date(this.maintenance?.start_time);
      this.localtime = date.toString();
      if (this.maintenance.time_is_coming) {
        this.countdownTimeStart(this.maintenance.time_is_coming);
        this.isComming = true;
      } else {
        this.isComming = false;
      }
    }
    let getTabName = new URLSearchParams(historyState.current?.split('?')[1]);
    let cate = getTabName.get('cate');
    this.currentPath = historyState?.current;
    this.prevPath = historyState?.back;
    this.prevCate = this.exploreRelatedCategory;
    const basePath = this.prevPath?.split('/').slice(0, 4).join('/');
    if (
      (!historyState.forward && historyState.forward !== null) ||
      historyState.forward?.indexOf('product-detail') === -1
    ) {
      this.resetSearch({
        cate: cate ? cate : TAB_CATEGORY.HISTORY,
        checkCate: (cate ? cate : TAB_CATEGORY.HISTORY) + '-'
      });
    } else if (historyState.forward === null && basePath === '/b2b/main/product-detail') {
      this.isExploreProduct = true;
      this.currentFilter = SORTBY_FILTER_NAME.POPULAR;
      this.resetSearch({
        cate: this.prevCate,
        checkCate: this.prevCate + '-'
      });
    }
    this.isPageRefreshed = true;
    await this.handleGetConnectPerson();
    // change all or newest category when user click notification.
    if (this.$router.currentRoute._rawValue.query.filter) {
      this.changeCategory = this.$router.currentRoute._rawValue.query.filter;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path === '/b2b/search-products') {
      this.setIsHomePageValue();
    }
    next();
  },
  computed: {
    ...mapGetters(['loading', 'list', 'search', 'isChangeAllCategory']),
    ...mapGettersCart(['finishOrder']),
    ...mapGettersVersion(['maintenance']),
    ...mapGettersCustomer(['selectedCustomer']),
    ...mapGettersExploreTabCategory(['exploreRelatedCategory']),
    isShowInfinityScroll() {
      if (this.loading) return true;
      return this.list.items.length < this.list.totalCount;
    }
  },
  watch: {
    isChangeAllCategory() {
      this.setLoadAllProducts(true);
      this.changeCategory = this.selectedTab;
    },
    loading(value) {
      // move to all only on home page and will not triggered on other page
      if (!value && this.list?.totalCount <= 0 && this.search.mainCategoryId !== TAB_CATEGORY.ALL) {
        this.moveToAll();
      }
    },
    async isPageRefreshed() {
      if (!this.isPageRefreshed && this.currentPath === '/b2b/main/home') {
        await this.getConnectPerson();
      }
    },
    selectedCustomer: {
      async handler(newCompany, oldCompany) {
        if (oldCompany && newCompany && newCompany.id !== oldCompany.id) {
          this.changeCategory = TAB_CATEGORY.HISTORY;
          this.resetSearch({
            cate: TAB_CATEGORY.HISTORY,
            checkCate: TAB_CATEGORY.HISTORY + '-'
          });
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([ACTIONS.UPDATE_SEARCH]),
    ...mapActionsCart([ACTIONS_CART.FINISH_ORDER]),
    ...mapMutations([MUTATIONS.RESET_CATEGORY]),
    async reFetchSelectedCompany() {
      this.selectedCompany = await this.$storage.getSelectedCompany();
    },
    async handleGetConnectPerson() {
      if (!this.user.id || this.user.is_b2c) return;
      try {
        const { data } = await apolloClient.query({
          query: checkConnectPerson,
          variables: {
            userId: this.user.id
          }
        });
        if (data.checkConnectPerson?.length === 1) {
          const info = data.checkConnectPerson[0]?.sale_user_name || 'Admin';
          let isRequestedByBuyer = USER_TYPE.B2B.includes(data.checkConnectPerson[0]?.user_type_id);
          const message = !isRequestedByBuyer
            ? this.$t('new_request_info', {
                applicant: info,
                supplierName: data.checkConnectPerson[0]?.supplier_name,
                position: data.checkConnectPerson[0]?.position?.toLowerCase(),
                customerName: data.checkConnectPerson[0]?.customer_name
              })
            : this.$t('new_request_buyer', {
                applicant: info,
                position: data.checkConnectPerson[0]?.position?.toLowerCase(),
                customerName: data.checkConnectPerson[0]?.customer_name
              });

          this.presentAlert(message);
        } else if (data.checkConnectPerson?.length > 1) {
          const message = this.$t('new_assigned_company', {
            connectedPersons: data.checkConnectPerson.length
          });
          this.presentAlert(message);
        }
      } catch (error) {
        console.log(`echo: handleGetConnectPerson ERROR ${error.message}`);
      }
    },
    async presentAlert(message) {
      const alert = await alertController.create({
        mode: 'ios',
        cssClass: 'my-custom-class',
        header: this.$t('new_request'),
        message: message,
        buttons: [
          {
            text: this.$t('dismiss'),
            role: 'dismiss',
            cssClass: 'secondary',
            id: 'cancel-button'
          },
          {
            text: this.$t('view_details'),
            id: 'confirm-button',
            handler: () => {
              this.$router.push('/b2b/customers');
            }
          }
        ]
      });
      await alert.present();
    },
    countdownTimeStart(params) {
      this.countDownDate = new Date().getTime() + Number(params);
      const data = setInterval(() => {
        if (this.$router.currentRoute._value.href === '/b2b/main/home') {
          var now = new Date().getTime();
          const distance = Number(this.countDownDate) - Number(now);
          this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        } else {
          clearInterval(data);
          return;
        }
      }, 1000);
    },
    async getConnectPerson() {
      await this.handleGetConnectPerson();
      this.isPageRefreshed = true;
    },
    resetSearch(value) {
      this.search.searchQueries = '';
      this.isResetSearch = value;
      this.selectedTab = value.cate;
      this.changeCategory = this.selectedTab;
    },
    resetRef() {
      this.isPageRefreshed = false;
    },
    clearPrevFilter() {
      this.currentFilter = '';
    },
    setExploreProduct() {
      this.isExploreProduct = false;
    },
    async moveToAll() {
      const category = TAB_CATEGORY.ALL;
      this.changeCategory = TAB_CATEGORY.ALL;
      this.onSetDefaultSort(category);
      const sortItemKey = this.$store.getters[`${MODULES_FILTER}/${GETTER.GET_FILTER}`];
      const itemSort = getItemByKey({ categoryName: category, key: sortItemKey });

      const searchOptions = {
        sortBy: itemSort.sortBy,
        sortType: itemSort.sortType,
        mainCategoryId: category
      };
      if (this.search.mainCategoryId === category) {
        searchOptions.searchQueries = '';
      }

      await this[ACTIONS.UPDATE_SEARCH]({
        search: searchOptions,
        type: TYPE_SEARCH.CATEGORY
      });
    },
    setIsHomePageValue() {
      this.isHomePage = false;
    },
    async loadData(e) {
      try {
        if (this.noProductIsLoaded) return;

        this.noProductIsLoaded = true;

        if (!this.loading) {
          let offsetSize = this.search.offset;
          const length = this.list.items.length;
          if (length === this.list.totalCount || this.offsetSize >= this.list.totalCount) {
            e.target.disabled = true;
            offsetSize = 0;
          } else {
            offsetSize += defaultSize;
            const sortItemKey = this.$store.getters[`${MODULES_FILTER}/${GETTER.GET_FILTER}`];
            const itemSort = getItemByKey({ categoryName: this.list.category, key: sortItemKey });

            await this[ACTIONS.UPDATE_SEARCH]({
              search: {
                sortType: this.changeCategory === TAB_CATEGORY.HISTORY ? 'desc' : itemSort?.sortType,
                sortBy: this.isExploreProduct
                  ? SORTBY_FILTER_NAME.POPULAR
                  : this.changeCategory === TAB_CATEGORY.HISTORY
                  ? SORTBY_FILTER_NAME.PURCHASED
                  : itemSort?.sortBy,
                offset: offsetSize
              },
              isLoadMore: true,
              type: TYPE_SEARCH.CATEGORY
            });
            e?.target.complete();
          }
        }
      } catch (error) {
        this.noProductIsLoaded = true;
      } finally {
        this.noProductIsLoaded = false;
      }
    }
  }
});
</script>
<style lang="scss" scoped>
ion-header {
  background-color: white;
}
.default-background {
  --background: #f5f5f5;
}
.wrapper {
  width: 100%;
  background: #fdc40c0f;
  padding: 12px 20px;
  & > .title {
    font-size: 14px;
    list-style: 14px;
    font-weight: 700;
    color: #181818;
  }
  & > .time {
    font-size: 14px;
  }
}
</style>
